import { MenuItem, TextField } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setPlace as setPlaceAction } from '../../actions/schedule';
import { places } from '../../constants/places';
import { PLACE_FOR_CLASS_LABEL } from '../../constants/translationLabels/common';

const SelectPlace = () => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const place = useSelector((state) => state.schedule.place);

    const handleChange = ({ target }) => {
        if (target) {
            dispatch(setPlaceAction(target.value));
            localStorage.setItem('place', target.value);
        }
    };

    return (
        <div id="select-place">
            <TextField
                select
                className="place"
                id="demo-controlled-open-select"
                label={t(PLACE_FOR_CLASS_LABEL)}
                value={place}
                onChange={handleChange}
            >
                {Object.entries(places).map(([key, value]) => (
                    <MenuItem value={value} key={key}>
                        {t(`${value}_label`)}
                    </MenuItem>
                ))}
            </TextField>
        </div>
    );
};

export default SelectPlace;
